<!-- Base dialog component that wraps the entire filter dialog -->
<dhp-filter-accordion [filterName]="filterName()">
  <div class="h-full overflow-y-auto">
    <div class="flex h-11 items-center justify-between px-6">
      <div class="flex items-center">
        <div
          class="truncate text-base leading-normal font-normal text-primary-text"
        >
          {{ selectedStrings().size }}
          {{ 'components.filter.selected' | translate }}
        </div>
      </div>
      <button
        class="text-base leading-normal font-normal"
        [class.text-orange-500]="selectedStrings().size > 0"
        [class.font-medium]="selectedStrings().size > 0"
        [class.text-neutral-300]="selectedStrings().size === 0"
        [disabled]="selectedStrings().size === 0"
        (click)="onClearSelection()"
      >
        {{ 'components.filter.clearSelection' | translate }}
      </button>
    </div>
    @if (isSearchOptionEnabled()) {
      <dhp-filter-items-search-bar
        [placeholder]="filterName()"
        (searchTermOutput)="onSearchTermChange($event)"
      />
    }
    <!-- No Results -->
    @if (strings().size <= 0) {
      <dhp-filter-items-no-result />
    }
    <div class="flex flex-col">
      @for (stringItem of strings(); track stringItem) {
        <dhp-filter-strings-checkbox
          [currentString]="stringItem"
          [isSelected]="isSelected(stringItem)"
          (selected)="onItemSelectedChange($event)"
        />
      }
    </div>
  </div>
</dhp-filter-accordion>
